import * as React from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'motion/react';
import boxImage from './box.png';
import styles from './index.less';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';

interface LuckyBoxProps {
  stage: 1 | 2 | 3;
  disabled?: boolean;
  showBox: boolean;
  onResult?: (
    results: {
      imgUrl: string;
      name: string;
    }[],
  ) => void;
}

function LuckyBox({ stage, disabled = false, showBox, onResult }: LuckyBoxProps) {
  const [$isShaking, set$isShaking, get$isShaking] = FUtil.Hook.useGetState(false);
  const [$showResult, set$showResult, get$showResult] = FUtil.Hook.useGetState(false);
  const [$results, set$results, get$results] = FUtil.Hook.useGetState<
    {
      imgUrl: string;
      name: string;
    }[]
  >([]);

  const handleClick = () => {
    console.log('handleClick 8392yhrioufsledklkj');
    if (get$isShaking() || get$showResult()) return;

    // 开始摇动动画
    set$isShaking(true);

    // 1秒后显示结果
    setTimeout(() => {
      handleResult();
    }, 500);
  };

  async function handleResult() {
    // set$results(results);
    // set$showResult(true);
    const {
      data,
    }: {
      data: {
        data: {
          capsuleType: 1 | 2 | 3;
          imgUrl: string;
          name: string;
        };
      }[];
    } = await FServiceAPI.Activity.lotteryDraw({
      capsuleType: stage,
      num: 3,
    });
    const results = data.map((d) => ({ imgUrl: d.data.imgUrl, name: d.data.name }));
    set$isShaking(false);
    set$results(results);
    set$showResult(true);
    onResult?.(results);
  }

  function handleReset() {
    set$showResult(false);
    // set$results([]);
  }

  return (
    <>
      {showBox && (
        <div className={styles.container}>
          <div className={styles.boxWrapper} style={{ opacity: disabled ? 0.4 : 1 }}>
            {/* 福袋盒子 */}
            <motion.div
              className={styles.box}
              whileHover={!$isShaking && !$showResult ? { scale: 1.2 } : {}}
              animate={
                $isShaking
                  ? {
                      rotate: [0, -15, 15, -15, 15, -10, 10, -5, 5, 0],
                      transition: {
                        duration: 1,
                        ease: 'easeInOut',
                      },
                    }
                  : {}
              }
              onClick={handleClick}
              style={{
                filter: $showResult ? 'drop-shadow(0 0 40px rgba(255, 215, 0, 0.8))' : 'none',
              }}
            >
              <img src={boxImage} alt='Lucky Box' className={styles.boxImage} />

              {/* 光晕效果 */}
              <AnimatePresence>
                {$showResult && (
                  <>
                    <motion.div
                      className={styles.halo1}
                      initial={{ opacity: 0, scale: 0.8 }}
                      animate={{
                        opacity: [0, 0.6, 0],
                        scale: [0.8, 1.5, 1.8],
                      }}
                      transition={{
                        duration: 1.5,
                        repeat: Infinity,
                        ease: 'easeOut',
                      }}
                      style={{
                        background:
                          'radial-gradient(circle, rgba(255, 215, 0, 0.6) 0%, transparent 70%)',
                        filter: 'blur(20px)',
                      }}
                    />
                    <motion.div
                      className={styles.halo2}
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{
                        opacity: [0, 0.4, 0],
                        scale: [0.9, 1.3, 1.6],
                      }}
                      transition={{
                        duration: 1.5,
                        repeat: Infinity,
                        ease: 'easeOut',
                        delay: 0.3,
                      }}
                      style={{
                        background:
                          'radial-gradient(circle, rgba(255, 165, 0, 0.5) 0%, transparent 70%)',
                        filter: 'blur(25px)',
                      }}
                    />
                  </>
                )}
              </AnimatePresence>
            </motion.div>
          </div>
          {disabled && <div className={styles.disabledTip}>活动暂未开始，请耐心等待～</div>}
          {/* {!showResult && (
          <p className={styles.hint}>{isShaking ? '抽奖中...' : '将鼠标悬停可预览,点击开始抽奖'}</p>
        )} */}
        </div>
      )}

      {/* 抽奖结果 - 使用 Portal 渲染到 body 下 */}
      {typeof document !== 'undefined' &&
        createPortal(
          <AnimatePresence>
            {$showResult && (
              <>
                {/* 背景遮罩 */}
                <motion.div
                  className={styles.overlay}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  onClick={handleReset}
                />

                {/* 结果展示 */}
                <motion.div
                  className={styles.resultModal}
                  initial={{ opacity: 0, y: -50, scale: 0.8 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.8 }}
                  transition={{ duration: 0.5, ease: 'backOut' }}
                >
                  <div
                    className={styles.resultContent}
                    // style={{ background: 'rgba(0, 0, 0, 0.40)' }}
                  >
                    {/* 闪光效果 */}
                    {/* <motion.div
                      className={styles.shine}
                      animate={{
                        x: ['-100%', '200%'],
                      }}
                      transition={{
                        duration: 2,
                        repeat: Infinity,
                        ease: 'linear',
                      }}
                    /> */}

                    <div className={styles.resultInner}>
                      {/* <p className={styles.resultTitle}>🎊 恭喜您获得 🎊</p> */}

                      {/* 三个抽奖结果并排展示 */}
                      <div className={styles.resultsGrid}>
                        {$results.map((result, index) => (
                          <motion.div
                            key={index}
                            className={styles.resultItem}
                            initial={{
                              opacity: 0,
                              scale: 0.5,
                              rotate: -10,
                            }}
                            animate={{
                              opacity: 1,
                              scale: 1,
                              rotate: 0,
                            }}
                            transition={{
                              delay: index * 0.15,
                              duration: 0.4,
                              ease: 'backOut',
                            }}
                          >
                            <img
                              src={result.imgUrl}
                              alt='Lucky Box'
                              style={{ width: 360, height: 360, display: 'block' }}
                            />
                            <p className={styles.resultText}>{result.name}</p>
                          </motion.div>
                        ))}
                      </div>

                      <div className={styles.buttonWrapper}>
                        <button onClick={handleReset} className={styles.confirmButton}>
                          确定
                        </button>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </>
            )}
          </AnimatePresence>,
          document.body,
        )}
    </>
  );
}

export default LuckyBox;
